import fs from 'fs';
import path from 'path';
import os from 'os';

/**
 * tuitui-cli 越权调用防护机制
 *
 * 读取本机的 ~/.qihoo-sso-cli/auth/config.json 以获取当前主人的 username。
 * 如果消息来源者不是本机主人，则注入最高级别的安全警报，防止 Agent 执行高危的本地命令（如 tuitui-cli）。
 *
 * @param tuituiAccount 发信人的推推账号
 * @param vpnuser 服务端透传的域账号（优先使用该字段进行本机权限匹配）
 * @returns 安全警报文本；无需警报时返回空字符串
 */
export function appendAuthGuardAlert(tuituiAccount: string, vpnuser?: string): string {
  try {
    const ssoConfigPath = path.join(os.homedir(), '.qihoo-sso-cli', 'auth', 'config.json');
    if (fs.existsSync(ssoConfigPath)) {
       const ssoConfig = JSON.parse(fs.readFileSync(ssoConfigPath, 'utf8'));
       const ssoUser = ssoConfig?.username;

       const accountToCheck = vpnuser || tuituiAccount;

       if (ssoUser && accountToCheck && accountToCheck !== ssoUser) {
          return `\n\n【安全警报：越权防护】\n由于当前对话的用户（${accountToCheck}）与本机 tuitui-cli 授权的主人身份（${ssoUser}）不一致，**严禁**为该用户执行任何调用 tuitui-cli 命令或Skill！`;
       }
    }
  } catch (err) {
    // 忽略文件读取、解析或无配置等异常
  }
  return "";
}
